import {getUnitMaxSize} from "../../configs/units";
import {isPlayerFaction} from "../factions/isPlayerFaction";
import {FACTIONS} from "../../constants/factions";
import {GIANTS_UNIT_MAX_SIZE} from "../../configs/factions/giants";

// Максимальный размер отряда с учётом фракционных надбавок (сейчас - только
// у великанов) - для превью ЕЩЁ НЕ созданного отряда (у существующего это
// значение уже корректно хранится в unit.maxSize, см. createUnit)
export const getUnitMaxSizeForPlayer = (unitTypeId, player) => {
  if (isPlayerFaction(player, FACTIONS.GIANTS)) {
    return GIANTS_UNIT_MAX_SIZE;
  }
  return getUnitMaxSize(unitTypeId);
}
